
import React, { ReactElement, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import AccountLayout from '../layouts/account/account';


export default function PrivateRoute({ isAuthenticated }: { isAuthenticated: boolean }): ReactElement {

  useEffect(() => {
    window.addEventListener("popstate", () => {
      history.go(1)
    })
  }, [])


  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <AccountLayout>
      <Outlet />
    </AccountLayout>
  )
}

